import { InputMaybe } from "src/generated/graphql";
import { Scalars } from "./scalars";
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export class Awards{
    id: Scalars['ID'];
    name: Scalars['String'];
    image: Scalars['String'];
    value: Scalars['Float'];
    quantity: Scalars['Int'];
    deletedAt: Scalars['String'];
    category: Scalars['String'];
    reserved: Scalars['Float'];
    status: Scalars['Boolean'] = true;
    role?: Scalars['String'];
}

export type GetAllAwardsQueryVariables = Exact<{
    keyword: Scalars['String'];
  }>;
  
export type GetAllAwardsQuery = { getAllAwards: Awards[] };
export class RemoveAwardsInput{
    id: Scalars['ID'];
    role: Scalars['String'];
}

export type RemoveAwardMutationVariable = Exact<{
    data: RemoveAwardsInput;
}>

export type RemoveAwardMutation = {
    removeAward: { id: string,  role: string};
}

export type CreateAwardMutationVariable = Exact<{
    data: Awards;
}>

export type CreateAwardMutation = {
    createAwards: {id: string, name: string, image:string, value: number, quantity: number}
}

export class UpdateAwardsInput{
    data: Awards;
    role: Scalars['String'];
}

export type UpdateAwardMutation = {
    updateAwards: {id: string};
}

export type UpdateAwardMutationVariable = Exact<{
    data: Awards;
    role: String;
}>

export type UploadFileResponse = {
    fileName: string;
    requestId: string;
    eTag: string;
    versionId: string;
}

// ------------------- SEARCH
export type SearchAwardsQuery = Exact<{ searchAwards: Awards[] }>

export class SearchAwardsInput {
    name?: InputMaybe<Scalars['String']>;
};

export type SearchAwardsQueryVariables = Exact<{
    input: SearchAwardsInput;
}>;